import { ServiceWorkerPresence } from './types';

type RegistrationWorkers = Pick<ServiceWorkerRegistration, 'active' | 'waiting' | 'installing'>;

/**
 * The page's presence of a worker from its registration. A page without a
 * controller is not missing one: after a hard reload the worker is active and
 * takes the page over later, so only the registration tells.
 */
export function describeServiceWorkerPresence(registration: RegistrationWorkers | undefined): ServiceWorkerPresence {
  const hasWorker = Boolean(registration && (registration.active || registration.waiting || registration.installing));
  return hasWorker ? ServiceWorkerPresence.present : ServiceWorkerPresence.missing;
}
